import React, { forwardRef } from 'react';

const Input = forwardRef(
  (
    {
      label,
      type = 'text',
      placeholder,
      error,
      helpText,
      leftIcon,
      rightIcon,
      fullWidth = true,
      disabled = false,
      className = '',
      ...props
    },
    ref
  ) => {
    const baseClasses =
      'px-4 py-2.5 border rounded-xl transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-emerald-500/50 focus:border-transparent disabled:opacity-50 disabled:cursor-not-allowed bg-white/5 text-white placeholder-[#d8d2c5]/50';
    const errorClasses = error
      ? 'border-red-400/50 bg-red-500/10'
      : 'border-white/10 hover:border-white/20';
    const widthClass = fullWidth ? 'w-full' : '';
    let paddingClass = '';
    if (leftIcon) {
      paddingClass = 'pl-11';
    } else if (rightIcon) {
      paddingClass = 'pr-11';
    }

    return (
      <div className={`${fullWidth ? 'w-full' : ''}`}>
        {label && <label className="block text-sm font-semibold text-white mb-2">{label}</label>}
        <div className="relative">
          {leftIcon && (
            <div className="absolute left-3 top-1/2 -translate-y-1/2 text-[#d8d2c5]">
              {leftIcon}
            </div>
          )}
          <input
            ref={ref}
            type={type}
            placeholder={placeholder}
            disabled={disabled}
            className={`${baseClasses} ${errorClasses} ${widthClass} ${paddingClass} ${className}`}
            {...props}
          />
          {rightIcon && (
            <div className="absolute right-3 top-1/2 -translate-y-1/2 text-[#d8d2c5]">
              {rightIcon}
            </div>
          )}
        </div>
        {error && <p className="mt-1.5 text-sm text-red-400">{error}</p>}
        {helpText && !error && <p className="mt-1.5 text-sm text-[#d8d2c5]/70">{helpText}</p>}
      </div>
    );
  }
);

Input.displayName = 'Input';

export default Input;
